<template>
  <div class="custom-input">
    <input
      :id="id"
      :type="calcType"
      :class="{'switch': type === 'switch' }"
      :name="id"
      :checked="value === id"
      :value="id"
      @change="$emit('input', $event.target.value)"
    />
    <label :for="id"><slot></slot></label>
  </div>
</template>

<script>
export default {
  name: 'CustomInput',
  props: {
    type: {
      type: String,
      default: 'radio'
    },
    id: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    calcType() {
      return this.type === 'switch' ? 'checkbox' : this.type;
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  font-size: 1rem;
  display: flex;
}
.custom-input{
  position: relative;
  display:inline-flex;
  align-content: center;
  margin-right: 1rem;
  min-height: 1.5rem;
}
@supports (-webkit-appearance: none) or (-moz-appearance: none) {
  input[type='checkbox'],
  input[type='radio'] {
    --active: #{$blue};
    --active-inner: #{get-color('clear')};
    --focus: 2px rgba(39, 94, 254, 0.3);
    --border: #bbc1e1;
    --border-hover: #{$blue};
    --background: #{get-color('clear')};
    --disabled: #f6f8ff;
    --disabled-inner: #e1e6f9;
    -webkit-appearance: none;
    -moz-appearance: none;
    height: 1rem;
    width: 1rem;
    top:.25rem;
    outline: none;
    display: inline-block;
    vertical-align: top;
    position: absolute;
    margin: 0;
    cursor: pointer;
    border: 1px solid var(--bc, var(--border));
    background: var(--b, var(--background));
    left: 0;
    transition: background 0.3s, border-color 0.3s, box-shadow 0.2s;
    &:after {
      content: '';
      display: block;
      left: 0;
      top: 0;
      position: absolute;
      transition: transform var(--d-t, 0.3s) var(--d-t-e, ease),
        opacity var(--d-o, 0.2s);
    }
    &:checked {
      --b: var(--active);
      --bc: var(--active);
      --d-o: 0.3s;
      --d-t: 0.6s;
      --d-t-e: cubic-bezier(0.2, 0.85, 0.32, 1.2);
    }
    &:disabled {
      --b: var(--disabled);
      cursor: not-allowed;
      opacity: 0.9;
      &:checked {
        --b: var(--disabled-inner);
        --bc: var(--border);
      }
      & + label {
        cursor: not-allowed;
      }
    }
    &:hover {
      &:not(:checked) {
        &:not(:disabled) {
          --bc: var(--border-hover);
        }
      }
    }
    &:focus {
      //box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      box-shadow: 0 0 0 var(--focus);
    }
    &:not(.switch) {
      &:after {
        opacity: var(--o, 0);
      }
      &:checked {
        --o: 1;
      }
    }
    & + label {
      font-size: 1rem;
      line-height: 1.5rem;
      display: inline-block;
      vertical-align: top;
      cursor: pointer;
      position:relative;
      margin: 0;
      padding-left: 1.5rem;
    }
  }
  input[type='checkbox'] {
    width: 21px;
    height: 21px;
    &:not(.switch) {
      border-radius: 7px;
      &:after {
        width: 5px;
        height: 9px;
        border: 2px solid var(--active-inner);
        border-top: 0;
        border-left: 0;
        left: 7px;
        top: 4px;
        transform: rotate(var(--r, 20deg));
      }
      &:checked {
        --r: 43deg;
      }
    }
    &.switch {
      width: 38px;
      border-radius: 11px;
      &:after {
        left: 2px;
        top: 2px;
        border-radius: 50%;
        width: 15px;
        height: 15px;
        background: var(--ab, var(--border));
        transform: translateX(var(--x, 0));
      }
      &:checked {
        --ab: var(--active-inner);
        --x: 17px;
      }
      &:disabled {
        &:not(:checked) {
          &:after {
            opacity: 0.6;
          }
        }
      }
    }
  }
  input[type='radio'] {
    border-radius: 50%;
    &:after {
      width: 0.8675rem;
      height: 0.8675rem;
      border-radius: 50%;
      background: var(--active-inner);
      opacity: 1;
      transform: scale(var(--s, 0.7));
    }
    &:checked {
      --s: 0.5;
    }
  }
}
</style>
